/// <amd-module name="typeahead/core/logging/PerformanceMetricsLogger" />

import {CollectorTransport} from "typeahead/core/logging/CollectorTransport";
import {PerformanceMetrics} from "typeahead/core/logging/PerformanceMetrics";
import TypeaheadErrorLogger from "typeahead/core/logging/TypeaheadErrorLogger";
import {ElementFocusedMessage} from "typeahead/core/message/ElementFocusedMessage";
import {EssErrorMessage} from "typeahead/core/message/EssErrorMessage";
import {InputValueEditedMessage} from "typeahead/core/message/InputValueEditedMessage";
import {SuggestionReadyMessage} from "typeahead/core/message/SuggestionReadyMessage";
import {SuggestionShownMessage} from "typeahead/core/message/SuggestionShownMessage";
import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";
import {UserExitedMessage} from "typeahead/core/message/UserExitedMessage";

export class PerformanceMetricsLogger {

    private readonly TRIGGER_TYPE_FOCUS = "focus";
    private readonly TRIGGER_TYPE_INPUT = "input";
    private metrics: PerformanceMetrics = new PerformanceMetrics();

    constructor() {
        TypeaheadMessage.subscribe(
            ElementFocusedMessage.getTopic(), (topic: string, message: ElementFocusedMessage) => {
                this.metrics.logRequest(this.TRIGGER_TYPE_FOCUS, message.getDomElementId(), "");
                PerformanceMetrics.logServiceEndpoint(message.getContext() && message.getContext().serviceUrl);
            },
        );

        TypeaheadMessage.subscribe(
            InputValueEditedMessage.getTopic(), (topic: string, message: InputValueEditedMessage) => {
                if (message.getNewInputValue() !== "") { // No request is made when user clears all the text
                    this.metrics.logRequest(
                        this.TRIGGER_TYPE_INPUT, message.getDomElementId(), message.getNewInputValue());
                }
            },
        );

        TypeaheadMessage.subscribe(
            SuggestionReadyMessage.getTopic(), (topic: string, message: SuggestionReadyMessage) => {
                this.metrics.logResponse(message.getDomElementId(), message.getQuery(),
            message.getSuggestions() ? message.getSuggestions().length : 0, message.getActiveEssTests(),
                    message.getMetadata());
            },
        );

         // Suggestions displayed
        TypeaheadMessage.subscribe(
            SuggestionShownMessage.getTopic(), (topic: string, message: SuggestionShownMessage) => {
                this.metrics.logResponseShown(message.getDomElementId(), message.getElementValue());
            },
        );

        TypeaheadMessage.subscribe(
            EssErrorMessage.getTopic(), (topic: string, message: EssErrorMessage) => {
                this.metrics.logError(message.getStatusCode());
            },
        );

        TypeaheadMessage.subscribe(
            UserExitedMessage.getTopic(), () => {
                this.emitMetrics();
            },
        );
    }

    private resetLogger(): void {
        this.metrics = new PerformanceMetrics();
    }

    private emitMetrics(): void {
        this.emitToSplunk();
        this.emitToCollector();
        this.resetLogger();
    }

    private emitToSplunk(): void {
        const metric = this.metrics.getAggregatedMetric();
        if (metric) {
            TypeaheadErrorLogger.log(undefined, undefined, undefined, metric);
        }
    }

    private emitToCollector(): void {
        const logEntries = this.metrics.getAllEntries();
        if (logEntries && logEntries.length) {
            new CollectorTransport().log(logEntries, "typeahead_performance");
        }
    }
}
